<template>
  <v-text-field
    type="number"
    :label="label"
    :value="value"
    @input="$emit('input', $event)"
  />
</template>

<script>
export default {
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  created() {
    // Set initial value to current year
    this.$emit('input', new Date().getFullYear())
  }
}
</script>
